import React from 'react';
import { InputLabel } from '@material-ui/core';
import { SnackbarProvider, useSnackbar } from 'notistack';
import { Redirect } from 'react-router-dom';
import { AsyncStorage } from 'AsyncStorage';
import { CustomSpinner } from ".//CustomSpiner";
import {LogOut} from './LogOut'

function MyApp(params) {
  const { enqueueSnackbar } = useSnackbar();
  enqueueSnackbar(params.params.message, { variant: params.params.variant });
  params.params.clanMessage();
  return <InputLabel></InputLabel>;
}



 function IntegrationNotistackCustom(props) {

  // if(  props.message==='Token expired' ||
  //      props.message==='Token malformed'
  //      ){
  //       return <LogOut />;
  // }

  return (
    <SnackbarProvider maxSnack={1}>
        <MyApp params={props}/>
    </SnackbarProvider>
  );
}

export {IntegrationNotistackCustom}
